import * as types from '../constants/ActionTypes';
import {getInvoiceKey} from "../utils";

export function refreshInvoices() {
  return {
    type: types.FORCE_INVOICE_REFRESH,
    payload: {},
  }
}

export const invoiceInitialState = {
  forceRefresh: 0, // sometimes we need to force the invoice list to refresh. Increment this number to do so.
  selected: {},
  invoiceDetail: {},
  completed: {
    invoices: {},
    detials: {},
  }
};

export function invoiceReducer(state = invoiceInitialState, action) {
  switch (action.type) {
    case types.ADD_INVOICE_TO_SELECTED:
      var key = getInvoiceKey(action.payload);
      return {
        ...state,
        selected: {
          ...state.selected,
          [key]: action.payload,
        },
        invoiceDetail: {
          ...state.invoiceDetail,
          [key]: {
            amount: action.payload.open_amount.toFixed(2),
            amountValidation: '',
            reason: '',
            comment: '',
          },
        }
      };
    case types.REMOVE_INVOICE_FROM_SELECTED:
      var key = getInvoiceKey(action.payload);
      let newState = {
        ...state,
        selected: {...state.selected},
        invoiceDetail: {...state.invoiceDetail}
      };
      delete newState.selected[key];
      delete newState.invoiceDetail[key];
      return newState;
    case types.UPDATE_PAY_AMOUNT_FOR_INVOICE:
      let reason = "";
      let currentDetails = state.invoiceDetail[action.payload.documentId];
      if(action.payload.overUnder === currentDetails.overUnder){
        reason = currentDetails.reason;
      }
      
      return {
        ...state,
        invoiceDetail: {
          ...state.invoiceDetail,
          [action.payload.documentId]: {
            ...currentDetails,
            amount: action.payload.amount,
            amountValidation: action.payload.amountValidation,
            reason: reason,
            overUnder: action.payload.overUnder,
          }
        }
      };
    case types.UPDATE_REASON:
      return {
        ...state,
        invoiceDetail: {
          ...state.invoiceDetail,
          [action.payload.documentId]: {
            ...state.invoiceDetail[action.payload.documentId],
            reason: action.payload.reason,
          }
        }
      };
    case types.UPDATE_REASON_COMMENT:
      return {
        ...state,
        invoiceDetail: {
          ...state.invoiceDetail,
          [action.payload.documentId]: {
            ...state.invoiceDetail[action.payload.documentId],
            comment: action.payload.comment,
          }
        }
      };
    case types.COPY_SELECTED_INVOICES_TO_COMPLETED:
      return {
        ...state,
        completed: {
          invoices: {
            ...state.selected,
          },
          details: {
            ...state.invoiceDetail,
          },
        },
      };
    case types.CLEAR_SELECTED_INVOICES:
      return {
        ...state,
        selected: {},
        invoiceDetail: {},
      };
    case types.FORCE_INVOICE_REFRESH:
      return {...state, forceRefresh: state.forceRefresh + 1};
    default:
      return {...state};
  }
}
